import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { LorenBaseFeature } from "../../../../shared/base-components/loren-base-feature/loren-base-feature";
import { LorenPeriod } from "../../../../shared/modules/loren-period-selector/interfaces/loren-period.interface";

@Component({
    selector: "loren-trace-period-selector-dialog",
    templateUrl: "./loren-trace-period-selector-dialog.component.html",
    styleUrls: ["./loren-trace-period-selector-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenTracePeriodSelectorDialogComponent extends LorenBaseFeature {
  private dialogRef = inject<MatDialogRef<LorenTracePeriodSelectorDialogComponent>>(MatDialogRef);

  lastSelectedPeriod: LorenPeriod;

  continue() {
    this.dialogRef.close({
      selectedPeriod: this.lastSelectedPeriod,
    });
  }
}
